import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { updateCurrentNavigationId } from '../actions/history.actions';

@Injectable()
export class HistoryEffects {
  public routerHistory$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(routerNavigatedAction),
    map((action) => updateCurrentNavigationId({navId: action.payload.event.id})),
  ));

  constructor(private actions$: Actions) {}
}
